module.exports = __webpack_public_path__ + "img/Ellipse 18.377ca143.svg";